/**
 * Dashboard section wrapper: header and the middle slot for {@link SessionsChart}.
 */

import * as React from 'react';
import { Filter, TrendingUp } from 'lucide-react';
import { CHART_LABELS } from '@/components/charts/chart-configs';
import { SessionsChart } from '@/components/charts/sessions/SessionsChart';
import { Button } from '@/components/forms/Button';
import { cn } from '@/lib/utils';

/** Dashboard widget: sessions-by-establishment chart. */
export const SessionsChartSection: React.FC = () => {
  const [showFilters, setShowFilters] = React.useState(false);
  const [hasFilters, setHasFilters] = React.useState(false);

  /** Open or close the chart filter toolbar. */
  function handleToggleFilters(): void {
    setShowFilters((prev) => !prev);
  }

  /** Filter chip — same header row as the title, hidden when no IE filter exists. */
  function renderFilterButton(): React.ReactNode {
    if (!hasFilters) return null;
    return (
      <Button
        preset="section-action"
        icon={Filter}
        tooltipText={CHART_LABELS.filter}
        className={cn(showFilters && 'section-action-button-active')}
        onClick={handleToggleFilters}
      />
    );
  }

  return (
    <div className="space-y-4">
      <div className="section-header">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-[var(--color-1-nuance-1)]" />
          <h3 className="text-xl font-semibold text-[var(--color-1-nuance-1)]">
            Séances par établissement
          </h3>
        </div>
        <div className="section-actions">{renderFilterButton()}</div>
      </div>
      <div>
        <SessionsChart showFilters={showFilters} onHasFiltersChange={setHasFilters} />
      </div>
    </div>
  );
};
